import { DefaultSplash } from "./Default";
import { FinalSplash } from "./Final";
import { GenderSplash } from "./GenderSplash";
import { TestimonialSplash } from "./TestimonialSplash";

export const SPLASH_LAYOUTS = {
  default: DefaultSplash,
  gender: GenderSplash,
  testimonial: TestimonialSplash,
  final: FinalSplash,
  // Add more splash layouts as needed
};
